<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.school_code="{ value: v }">
      <span
        class="BTablePublicationFormdata__link"
        v-text="v"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
} from '@/views/LKPublications/formdata/table-headers-not-started'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationFormdata',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
.BTablePublicationFormdata__link {
  white-space: nowrap;
}
</style>
